import { render, staticRenderFns } from "./LsRole.vue?vue&type=template&id=47528d34&scoped=true&"
import script from "./LsRole.vue?vue&type=script&lang=js&"
export * from "./LsRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47528d34",
  null
  
)

export default component.exports